import React from 'react';
import { FileTextIcon, DownloadIcon, MusicIcon, StarIcon } from 'lucide-react';
export interface SheetMusicItem {
  id: string;
  title: string;
  composer: string;
  instruments: string[];
  era: string;
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  tags: string[];
  pdfUrl: string;
  firebaseUrl?: string;
  thumbnailUrl?: string;
  isFavorite?: boolean;
}
interface SheetMusicCardProps {
  item: SheetMusicItem;
  darkMode: boolean;
  onView: (item: SheetMusicItem) => void;
  onDownload?: (item: SheetMusicItem) => void;
  onToggleFavorite?: (id: string, isFavorite: boolean) => void;
}
export const SheetMusicCard: React.FC<SheetMusicCardProps> = ({
  item,
  darkMode,
  onView,
  onDownload,
  onToggleFavorite
}) => {
  return <div className={`rounded-xl overflow-hidden shadow-sm transform-gpu will-change-transform transition-[transform,shadow] duration-200 hover:-translate-y-1 hover:shadow-md flex flex-col ${darkMode ? 'bg-navy-800/80' : 'bg-white'}`} style={{
    backfaceVisibility: 'hidden'
  }} data-id="element-11082">
      {/* Thumbnail or Default Image */}
      <div className="relative h-40 overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-11083">
        {item.thumbnailUrl ? <img src={item.thumbnailUrl} alt={`${item.title} sheet music`} className="w-full h-full object-cover" data-id="element-11084" /> : <div className={`w-full h-full flex items-center justify-center ${darkMode ? 'bg-navy-900/50' : 'bg-gray-100'}`} data-id="element-11085">
            <FileTextIcon className={`h-16 w-16 ${darkMode ? 'text-navy-700' : 'text-gray-300'}`} data-id="element-11086" />
          </div>}
        {/* Favorite Button (if enabled) */}
        {onToggleFavorite && <button onClick={() => onToggleFavorite(item.id, !item.isFavorite)} className="absolute bottom-2 right-2 p-1.5 rounded-full bg-white/80 hover:bg-white transition-colors" aria-label={item.isFavorite ? 'Remove from favorites' : 'Add to favorites'} data-id="element-11087">
            <StarIcon className={`h-4 w-4 ${item.isFavorite ? 'text-yellow-400 fill-current' : 'text-gray-400'}`} data-id="element-11088" />
          </button>}
      </div>
      {/* Content */}
      <div className="p-4 flex flex-col flex-grow" data-id="element-11089">
        <h3 className={`font-medium text-base ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-11090">
          {item.title}
        </h3>
        <p className={`text-sm mt-1 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-11091">
          {item.composer}
        </p>
        {/* Instruments */}
        <div className="flex flex-wrap mt-2 gap-1" data-id="element-11092">
          {item.instruments.map((instrument, index) => <div key={index} className={`flex items-center text-xs px-2 py-0.5 rounded-full ${darkMode ? 'bg-navy-900/50 text-gray-300' : 'bg-gray-100 text-gray-700'}`} data-id="element-11093">
              <MusicIcon className="h-3 w-3 mr-1" data-id="element-11094" />
              {instrument}
            </div>)}
        </div>
        {/* Actions */}
        <div className="mt-auto pt-4 flex space-x-2" data-id="element-11095">
          <button onClick={() => onView(item)} className="bg-transparent border-2 border-green-500 text-green-500 hover:bg-green-500/10 text-xs py-2 px-3 rounded-lg transition-colors flex-1 flex items-center justify-center" data-id="element-11096">
            <FileTextIcon className="h-3.5 w-3.5 mr-1.5 text-green-500" data-id="element-11097" />
            View PDF
          </button>
          {onDownload && <button onClick={() => onDownload(item)} className={`text-xs py-2 px-3 rounded-lg transition-colors flex items-center justify-center ${darkMode ? 'bg-navy-900/50 hover:bg-navy-700 text-white border border-navy-700' : 'bg-gray-100 hover:bg-gray-200 text-gray-800 border border-gray-200'}`} data-id="element-11098">
              <DownloadIcon className="h-3.5 w-3.5 mr-1.5" data-id="element-11099" />
              Download
            </button>}
        </div>
      </div>
    </div>;
};